/*
  TDP - bouton "Partager" en haut a droite des articles de blog (markup dans
  le bloc 'title' de sections/main-article.liquid).

  Fichier separe de tdp-article-share.js (barre de partage du bas) volontaire-
  ment : les deux snippets chargent leur script en <script defer>, et si les
  deux pointaient vers le meme fichier le navigateur l'executerait deux fois
  (il ne dedoublonne pas deux balises de meme src), ce qui attacherait deux
  fois le meme listener sur chaque bouton - donc double ecriture dans le
  presse-papiers. Deux fichiers = deux composants strictement independants.

  Comportement volontairement minimal (pas de panneau de partage maison) :
  - si le navigateur expose le partage natif (navigator.share, surtout mobile),
    on lui delegue tout, c'est la feuille de partage du systeme ;
  - sinon (desktop en majorite), on retombe sur la copie du lien, avec le meme
    message de succes que la barre du bas (window.accessibilityStrings.
    shareSuccess, alimente par general.share.success_message dans theme.liquid)
    pour ne pas avoir deux formulations differentes sur la meme page.
*/
document.querySelectorAll('.tdp-share-top__button').forEach(function (button) {
  button.addEventListener('click', function () {
    var url = button.getAttribute('data-url');
    var title = button.getAttribute('data-title');
    var container = button.closest('.tdp-share-top');
    var message = container ? container.querySelector('.tdp-share-top__message') : null;

    if (navigator.share) {
      // Le .catch() est indispensable : navigator.share rejette aussi quand
      // l'utilisateur ferme simplement la feuille de partage (AbortError),
      // ce qui remonterait sinon en erreur non geree dans la console.
      navigator.share({ url: url, title: title }).catch(function () {});
      return;
    }

    if (!navigator.clipboard) return;

    navigator.clipboard.writeText(url).then(function () {
      if (!message) return;
      message.textContent = window.accessibilityStrings ? window.accessibilityStrings.shareSuccess : '';
      message.classList.remove('visually-hidden');
    });
  });
});
